import styled from "@emotion/styled";

import { MergeWithOverwrite } from "src/common";
import { colors } from "src/theme";

const IconSpan = styled.span((props: { height: number, width: number }) => ({
  display: 'inline-flex',
  height: props.height,
  width: props.width,
}))

export type DocumentIconProps = MergeWithOverwrite<React.HtmlHTMLAttributes<HTMLSpanElement>, {
  width?: number,
  height?: number,
  color?: string,
}>;

export const DocumentIcon: React.FC<DocumentIconProps> = ({ width = 16, height = 16, color = colors.primary, ...props }) => (
  <IconSpan {...props} height={height} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 25 25" fill="none">
      <path d="M15.8553 21.9961H5.5C5.22386 21.9961 5 21.7722 5 21.4961V3.49609C5 3.21995 5.22386 2.99609 5.5 2.99609H19.5C19.7761 2.99609 20 3.21995 20 3.49609V17.1889M15.8553 21.9961L20 17.1889M15.8553 21.9961V17.6889C15.8553 17.4127 16.0791 17.1889 16.3553 17.1889H20M7.36842 7.11658H17.6316M7.36842 16.731H12.8947M7.36842 10.3214H17.6316M7.36842 13.5262H17.6316" stroke={color} strokeLinecap="round"/>
    </svg>
  </IconSpan>
);
